import React, { useState } from 'react';
import Editor from '@monaco-editor/react';
import '../Pipeline.css';

/**
 * FileTree
 *
 * Left-panel file selector + right-panel Monaco code viewer.
 * Works with an array of `{ path, content, type? }` objects.
 */

function getFileIcon(path) {
  const ext = path.split('.').pop().toLowerCase();
  const icons = {
    js: '📜', ts: '📘', jsx: '⚛️', tsx: '⚛️',
    py: '🐍', go: '🐹', java: '☕', rb: '💎', rs: '🦀',
    json: '📋', yaml: '⚙️', yml: '⚙️', toml: '⚙️',
    md: '📝', txt: '📄', sh: '🖥️', bash: '🖥️',
    dockerfile: '🐳', 'docker-compose': '🐳',
    html: '🌐', css: '🎨', scss: '🎨', sql: '🗃️',
    tf: '🏗️', hcl: '🏗️', env: '🔑',
  };
  return icons[ext] || '📄';
}

function getLanguage(path) {
  const ext = path.split('.').pop().toLowerCase();
  const name = path.split('/').pop().toLowerCase();
  if (name === 'dockerfile') return 'dockerfile';
  const map = {
    js: 'javascript', jsx: 'javascript',
    ts: 'typescript', tsx: 'typescript',
    py: 'python', rb: 'ruby', go: 'go',
    java: 'java', cs: 'csharp',
    json: 'json', yaml: 'yaml', yml: 'yaml', toml: 'ini',
    sh: 'shell', bash: 'shell', bat: 'bat',
    html: 'html', css: 'css', scss: 'scss',
    sql: 'sql', md: 'markdown', tf: 'hcl', hcl: 'hcl',
  };
  return map[ext] || 'plaintext';
}

function FileTree({ files = [], defaultSelected = 0 }) {
  const [selectedIdx, setSelectedIdx] = useState(defaultSelected);

  if (!files.length) {
    return (
      <div className="pipeline-empty">
        <div className="pipeline-empty-icon">📂</div>
        <p>No files generated yet.</p>
      </div>
    );
  }

  const selected = files[selectedIdx];

  return (
    <div className="pipeline-filetree-container">
      {/* Left panel – file list */}
      <div className="pipeline-filetree-panel">
        {files.map((f, i) => {
          const name = f.path.split('/').pop();
          return (
            <button
              key={f.path}
              className={`pipeline-file-item ${i === selectedIdx ? 'active' : ''}`}
              onClick={() => setSelectedIdx(i)}
              title={f.path}
            >
              <span className="pipeline-file-icon">{getFileIcon(f.path)}</span>
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{name}</span>
            </button>
          );
        })}
      </div>

      {/* Right panel – Monaco viewer */}
      <div className="pipeline-filetree-viewer">
        <div
          style={{
            padding: '6px 14px',
            fontSize: '0.78rem',
            color: '#64748b',
            background: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
            fontFamily: 'monospace',
          }}
        >
          {selected?.path}
        </div>
        <Editor
          height="calc(100% - 30px)"
          language={getLanguage(selected?.path || '')}
          value={selected?.content || ''}
          theme="vs-light"
          options={{
            readOnly: true,
            minimap: { enabled: false },
            scrollBeyondLastLine: false,
            fontSize: 13,
            lineNumbers: 'on',
            wordWrap: 'on',
            folding: true,
          }}
        />
      </div>
    </div>
  );
}

export default FileTree;
